import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const getPage = async (pageId) => {
  const pageRef = doc(db, 'pages', pageId);
  const snapshot = await getDoc(pageRef);
  if (!snapshot.exists()) {
    return null;
  }
  return { id: snapshot.id, ...snapshot.data() };
};

export const savePage = async (pageId, data) => {
  const pageRef = doc(db, 'pages', pageId);
  await setDoc(
    pageRef,
    {
      ...data,
      updatedAt: serverTimestamp()
    },
    { merge: true }
  );
};
